import React, { useState, useEffect } from "react";
import { Redirect, Link as RouterLink } from "react-router-dom";
// import { } from 'react-router';
import {
  Form,
  Input,
  Label,
  FormGroup,
  Button,
  FormText,
  Card,
  CardBody,
  Row
} from "@Comp";

import images from "@assets";

import { FaTwitter, FaFacebook, FaGoogle } from "react-icons/fa";

import "../style.scss";
import "../app.scss";
import { inject } from "mobx-react";
import validate from "validate.js";

import {
  TextField,
  Checkbox,
  Typography,
  Link,
  FormHelperText
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { history } from "../../../App";
import EmailVerificationModal from "./EmailVerificationModal";

const schema = {
  businessName: {
    presence: { allowEmpty: false, message: "is required" },
    length: {
      maximum: 32
    }
  },
  cipcRegNo: {
    presence: { allowEmpty: false, message: "is required" },
    length: {
      maximum: 32,
      minimum: 10
    },
    cipcValidate: true
  },

  businessEmailAddress: {
    presence: { allowEmpty: false, message: "is required" },
    email: true,
    length: {
      maximum: 64
    }
  },
  password: {
    presence: { allowEmpty: false, message: "is required" },
    length: {
      minimum: 8
    }
  },
  confirmPassword: {
    equality: "password",
    presence: { allowEmpty: false, message: "is required" }
  },
  policy: {
    presence: { allowEmpty: false, message: "is required" },
    checked: true
  }
};

const Registration = ({ commonStore }) => {
  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {}
  });

  const [err, setErr] = useState(null);
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [registeredEmail, setRegisteredEmail] = useState("");
  const [passwordForVerification, setPasswordForVerification] = useState(null);

  const [inputs, setInputs] = useState({
    businessName: "",
    businessEmailAddress: "",
    cipcRegNo: "",
    password: "",
    confirmPassword: ""
  });

  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState(formState => ({
      ...formState,
      isValid: errors ? false : true,
      errors: errors || {}
    }));
  }, [formState.values]);

  const useStyles = makeStyles(() => ({
    textField: {
      border: 2
    },
    policy: {
      marginTop: 2,
      display: "flex",
      alignItems: "center"
    }
  }));
  const classes = useStyles();

  const [agreedToTerms, updateAgreedToTerms] = useState(false);
  const socialMediaLogin = false;

  const handleChange = e => {
    const target = e.target; //current input field being modified
    const value = target.value;
    const name = target.name;
    setInputs(inputs => ({ ...inputs, [name]: value }));

    e.persist();
    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [e.target.name]:
          e.target.type === "checkbox" ? e.target.checked : e.target.value
      },
      touched: {
        ...formState.touched,
        [e.target.name]: true
      }
    }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    commonStore
      .register(inputs.businessEmailAddress, inputs.password)
      .then(() => {
        // Registration successful - save password and show verification modal
        commonStore.setLoading(false);
        setRegisteredEmail(inputs.businessEmailAddress);
        setPasswordForVerification(inputs.password);
        setShowVerificationModal(true);
      })
      .catch(function(e) {
        if (e.response) {
          commonStore.setLoading(false);
          // Extract error message from Strapi format
          const errorData = e.response.data;
          let errorMessage = 'Registration failed';

          if (errorData.message && Array.isArray(errorData.message) && errorData.message[0]?.messages?.[0]?.message) {
            errorMessage = errorData.message[0].messages[0].message;
          } else if (typeof errorData.message === 'string') {
            errorMessage = errorData.message;
          } else if (errorData.error) {
            errorMessage = errorData.error;
          }

          setErr(errorMessage);
        }
      });
  };

  const handleVerificationSuccess = () => {
    // Modal will handle verification, profile creation, and login
    // Just close the modal here (redirect happens in modal after login)
    setShowVerificationModal(false);
  };

  const handleCloseModal = () => {
    setShowVerificationModal(false);
  };

  const hasError = field =>
    formState.touched[field] && formState.errors[field] ? true : false;

  return (
    <div className="view">
      <div className="view-content view-content-reg view-pages view-session d-flex justify-content-center align-items-center flex-column">
        <Row className="register-row">
          <div className="col-md-7 mb-7 d-none d-md-block register-left-section">
            <div className="register-left-content">
              <div className="register-logo-wrapper">
                <img className="register-nisa-logo" src={images.nisaFinanceWhiteLogo} alt="NISA FINANCE" />
              </div>
              <div className="register-main-content">
                <div className="register-heading-wrapper">
                  <h1 className="register-heading">
                    Fast funding for <span className="register-highlight">your business</span>
                  </h1>
                  <p className="register-subtitle">
                    Take control of your cash flow with our flexible finance. No paperwork.
                  </p>
                </div>
                <div className="register-requirements">
                  <h3 className="register-requirements-title">All you need is:</h3>
                  <ul className="register-requirements-list">
                    <li className="register-requirement-item">
                      <span className="register-checkmark">✓</span>
                      <span>A registered company or close corporation in South Africa</span>
                    </li>
                    <li className="register-requirement-item">
                      <span className="register-checkmark">✓</span>
                      <span>Annual turnover of more than R500,000</span>
                    </li>
                    <li className="register-requirement-item">
                      <span className="register-checkmark">✓</span>
                      <span>A trading history of at least 6 months</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <Card className="col-md-5 mb-3 form-card register-card align-self-center">
            <CardBody className="register-card-body">
              <header className="mb-4 register-header">
                <h2 className="register-title">Create Your account</h2>
              </header>
              <Form onSubmit={handleSubmit} className="register-form">
                <FormGroup className="mb-4">
                  <TextField
                    type="text"
                    name="businessName"
                    placeholder="Business Name"
                    value={inputs.businessName}
                    fullWidth={true}
                    onChange={handleChange}
                    error={hasError("businessName")}
                    helperText={
                      hasError("businessName")
                        ? formState.errors.businessName[0]
                        : null
                    }
                    className={classes.textField}
                  />
                </FormGroup>
                <FormGroup className="mb-4">
                  <TextField
                    type="email"
                    name="businessEmailAddress"
                    placeholder="Email Address"
                    value={inputs.businessEmailAddress}
                    fullWidth={true}
                    onChange={handleChange}
                    error={hasError("businessEmailAddress")}
                    helperText={
                      hasError("businessEmailAddress")
                        ? formState.errors.businessEmailAddress[0]
                        : null
                    }
                    className={classes.textField}
                  />
                </FormGroup>
                <FormGroup className="mb-4">
                  <TextField
                    type="text"
                    name="cipcRegNo"
                    placeholder="CIPC Reg number - k2017/0092/93"
                    value={inputs.cipcRegNo}
                    fullWidth={true}
                    onChange={handleChange}
                    error={hasError("cipcRegNo")}
                    helperText={
                      hasError("cipcRegNo")
                        ? formState.errors.cipcRegNo[0]
                        : null
                    }
                    className={classes.textField}
                  />
                </FormGroup>
                <FormGroup className="mb-4">
                  <TextField
                    type="password"
                    name="password"
                    placeholder="password minimum 8 characters"
                    value={inputs.password}
                    fullWidth={true}
                    onChange={handleChange}
                    error={hasError("password")}
                    helperText={
                      hasError("password") ? formState.errors.password[0] : null
                    }
                    className={classes.textField}
                  />
                  <FormText>Minimum length 8 characters</FormText>
                </FormGroup>
                <FormGroup className="mb-4">
                  <TextField
                    type="password"
                    name="confirmPassword"
                    placeholder="confirm password above"
                    value={inputs.confirmPassword}
                    fullWidth={true}
                    onChange={handleChange}
                    error={hasError("confirmPassword")}
                    helperText={
                      hasError("confirmPassword")
                        ? formState.errors.confirmPassword[0]
                        : null
                    }
                    className={classes.textField}
                  />
                </FormGroup>
                <FormGroup className="mb-4">
                  <div className={classes.policy}>
                    <Checkbox
                      checked={formState.values.policy || false}
                      className={classes.policyCheckbox}
                      color="primary"
                      name="policy"
                      onChange={handleChange}
                    />
                    <Typography
                      className={classes.policyText}
                      color="textSecondary"
                      variant="body1"
                    >
                      I have read the{" "}
                      <Link
                        color="primary"
                        component={RouterLink}
                        to="#"
                        underline="always"
                        variant="body1"
                      >
                        Terms and Conditions
                      </Link>
                    </Typography>
                  </div>
                  {hasError("policy") && (
                    <FormHelperText error>
                      {formState.errors.policy[0]}
                    </FormHelperText>
                  )}
                </FormGroup>
                <FormGroup className="mb-3">
                  {err && err.length > 0 ? (
                    <Label className="err register-error">{err}</Label>
                  ) : null}
                </FormGroup>
                <FormGroup className="text-right">
                  <Button
                    color="info"
                    block
                    size="lg"
                    className={`btn-register-submit ${formState.isValid ? '' : 'disabled'}`}
                    type="submit"
                    disabled={!formState.isValid}
                  >
                    Create New Account
                  </Button>
                </FormGroup>
                <FormGroup className="register-login-link">
                  <Typography
                    className={classes.policyText}
                    color="textSecondary"
                    variant="body2"
                  >
                    Already have an account?{" "}
                    <Link
                      color="primary"
                      component={RouterLink}
                      to="/login"
                      underline="always"
                      variant="body2"
                    >
                      Login
                    </Link>
                  </Typography>
                </FormGroup>
              </Form>
              {socialMediaLogin ? (
                <div>
                  <p className="font-weight-bold">or sign up with...</p>
                  <ul className="list-unstyled social-auth">
                    <li>
                      <a href="#na">
                        <FaTwitter size={22} />
                      </a>
                    </li>
                    <li>
                      <a href="#na">
                        <FaFacebook size={22} />
                      </a>
                    </li>
                    <li>
                      <a href="#na">
                        <FaGoogle size={22} />
                      </a>
                    </li>
                  </ul>
                </div>
              ) : null}
            </CardBody>
          </Card>
        </Row>

        {/* Email Verification Modal */}
        <EmailVerificationModal
          isOpen={showVerificationModal}
          onClose={handleCloseModal}
          email={registeredEmail}
          password={passwordForVerification}
          businessData={{
            businessName: inputs.businessName,
            cipcRegNo: inputs.cipcRegNo,
            businessEmailAddress: inputs.businessEmailAddress
          }}
          onSuccess={handleVerificationSuccess}
        />
      </div>
    </div>
  );
};

const Register = inject("commonStore")(Registration);
export default Register;
